<template>
  <div>
    <v-app>
      <v-main>
        <div class="content-wrapper">
          <!-- AsideBar -->
          <AsideBar />
          <!-- Content Header -->
          <div class="content-header">
            <div
              class="d-flex align-items-center"
              style="
                border-bottom: 1px solid #5c4a4a17;
                margin: auto !important;
              "
            >
              <div class="row">
                <div class="col-12 d-flex flex-column align-items-baseline">
                  <router-link
                    tag="h1"
                    :to="{ name: 'Send' }"
                    class="m-0 text-dark"
                    >{{ currentRouteName }}</router-link
                  >
                  <ol class="breadcrumb float-sm-left">
                    <router-link
                      tag="li"
                      class="breadcrumb-item"
                      :to="{ name: 'Home' }"
                      >Home</router-link
                    >
                    <router-link
                      tag="li"
                      class="breadcrumb-item"
                      :to="{ name: 'Dashboard' }"
                      >Dashboard</router-link
                    >
                    <li
                      class="breadcrumb-item"
                      :class="{ active: $route.name === 'Recurring' }"
                      @click.stop="$router.push({ name: 'Recurring' })"
                    >
                      {{
                        isGroupedByChecked ||
                        $route.name === "GroupedRecurrings"
                          ? "Groups"
                          : "Notifications"
                      }}
                    </li>
                    <li
                      v-if="$route.name === 'GroupedRecurrings'"
                      class="breadcrumb-item active"
                    >
                      {{
                        isGroupedByChecked ||
                        $route.name === "GroupedRecurrings"
                          ? "Notifications"
                          : "Groups"
                      }}
                    </li>
                  </ol>
                  <div
                    v-if="!isGroupedByChecked"
                    class="position-absolute d-flex align-items-center h-100"
                    style="top: 0; right: 407px; max-height: 200px"
                  >
                    <v-menu
                      bottom
                      @input="toggleMenu"
                      :close-on-content-click="false"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="#1976d2"
                          style="font-size: 12px"
                          dark
                          v-bind="attrs"
                          v-on="on"
                        >
                          Sorting by:
                        </v-btn>
                      </template>
                      <v-treeview
                        :items="itemsSendTime"
                        :open="openTreeview"
                        @update:active="treeviewActiveSendTime"
                        activatable
                        hoverable
                      >
                        <template #label="{ item }">
                          <span
                            style="cursor: pointer"
                            @click="
                              loading = true;
                              obtainRecurringDrips({
                                itemsPerPage: itemsPerPage,
                                page: page,
                              });
                              loading = false;
                            "
                            >{{ item.name }}</span
                          >
                        </template>
                        <template #append="{ item }">
                          <div
                            v-if="item.id === 1"
                            class="d-flex flex-column align-items-center"
                          >
                            <v-text-field
                              label="Send Time"
                              v-model="sendTimeForSearching"
                              placeholder="Write the selected send time"
                            ></v-text-field>
                            <v-btn
                              @click="
                                obtainRecurringDrips({
                                  page: page,
                                  itemsPerPage: itemsPerPage,
                                })
                              "
                              color="success"
                              elevation="2"
                              x-small
                              style="height: 25px !important"
                              >Search</v-btn
                            >
                          </div>
                        </template>
                      </v-treeview>
                      <v-treeview
                        :items="itemsAudienceFilters"
                        :open="openTreeview"
                        v-model="selectedAudienceForSorting"
                        multiple-active
                        @update:active="treeviewActiveAudienceFilters"
                        activatable
                        hoverable
                        selectable
                      >
                        <template #label="{ item }">
                          <span style="cursor: pointer">{{ item.name }}</span>
                        </template>
                      </v-treeview>
                      <v-treeview
                        :items="externalAdverts"
                        :open="openTreeview"
                        v-model="selectedExternalForSorting"
                        @update:active="treeviewActiveExternal"
                        activatable
                        multiple-active
                        hoverable
                        selectable
                        item-key="name"
                      >
                        <template #label="{ item }">
                          <span style="cursor: pointer">{{ item.name }}</span>
                        </template>
                      </v-treeview>
                    </v-menu>
                  </div>
                  <div
                    v-if="!isGroupedByChecked"
                    class="position-absolute d-flex align-items-center pr-2"
                    style="height: 63px; padding: 10px; right: 276px"
                  >
                    <button
                      class="btn btn-sm btn-color--primary ml-7"
                      style="
                        width: fit-content;
                        padding: 7px;
                        background-color: #1976d2;
                      "
                      :disabled="!selectedDrips.length"
                      @click="shwSaveAsATailQuestionPopUp = true"
                    >
                      Save As A Tail
                    </button>
                  </div>
                  <div
                    v-if="!isGroupedByChecked"
                    class="position-absolute d-flex align-items-center pr-2"
                    style="height: 63px; padding: 10px; right: 16px"
                  >
                    <button
                      class="btn btn-sm btn-color--primary ml-7"
                      style="
                        width: fit-content;
                        padding: 7px;
                        background-color: #1976d2;
                      "
                      :disabled="!selectedDrips.length"
                      @click="
                        changeLinksPopUp = !changeLinksPopUp;
                        selectedDrips.length
                          ? null
                          : ((changeLinksPopUp = false), (warningPopUp = true));
                      "
                    >
                      Change Links
                    </button>
                  </div>
                  <div
                    v-if="!isGroupedByChecked"
                    class="position-absolute d-flex align-items-center pr-2"
                    style="height: 63px; padding: 10px; right: 133px"
                  >
                    <!-- Change Schedule Dialog -->
                    <v-dialog v-model="changeSchedulePopUp" width="400">
                      <template v-slot:activator="{ on, attrs }">
                        <!-- Change Schedule Button -->
                        <button
                          v-bind="attrs"
                          v-on="on"
                          class="btn btn-sm btn-color--primary ml-7"
                          :disabled="!selectedDrips.length"
                          style="
                            width: fit-content;
                            padding: 7px;
                            background-color: #1976d2;
                          "
                          @click="
                            changeSchedulePopUp = !changeSchedulePopUp;
                            selectedDrips.length
                              ? null
                              : ((changeSchedulePopUp = false),
                                (warningPopUp = true));
                          "
                        >
                          Change Schedule
                        </button>
                      </template>

                      <v-card class="m-0" style="margin: 0 !important">
                        <v-card-title class="text-h5 lighten-2">
                          Change Schedules
                        </v-card-title>

                        <v-card-text class="pt-5">
                          <!-- End Date Menu -->
                          <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="endDate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="endDate"
                                label="End Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :disabled="isDialogLoading"
                                :loading="isDialogLoading"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="endDate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menu = false">
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu.save(endDate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            :disabled="isDialogLoading"
                            :loading="isDialogLoading"
                            color="primary"
                            text
                            @click="changeSchedulePopUp = !changeSchedulePopUp"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            :disabled="isDialogLoading"
                            :loading="isDialogLoading"
                            color="primary"
                            @click="changeSchedule($event)"
                          >
                            Change
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </div>
                </div>
              </div>
              <router-link
                v-if="hasCreatorPermission && !isGroupedByChecked"
                class="btn mt-0 btn-color--primary"
                tag="button"
                :to="{ name: 'Send' }"
              >
                <em class="bi-bell-fill"></em>
                Create New Recurring
              </router-link>
            </div>
          </div>
          <!-- Data Table -->
          <v-card>
            <v-card-title
              class="d-flex align-items-start table-card-header--color height-70 pl-0"
            >
              <v-text-field
                v-model.lazy="search"
                @input="searchRecurring"
                append-icon="mdi-magnify"
                label="Search"
                class="ml-3 table-search-field--width"
                solo
                dense
              ></v-text-field>
              <v-checkbox
                v-if="isGroupByCheckboxVisible"
                v-model="isGroupedByChecked"
                label="Group Recurring Drips"
                :loading="loading"
                :disabled="loading || !hasGroupVisiblePermission"
                class="mt-0"
              ></v-checkbox>
              <v-btn
                v-if="isGroupByCheckboxVisible && isGroupedByChecked"
                class="ml-4"
                color="primary"
                :loading="loading"
                @click="isPopUpGroupCreationVisible = true"
              >
                Create Group
              </v-btn>
            </v-card-title>
            <v-data-table
              :headers="headers"
              @click:row="handleClick"
              calculate-widths
              :items="filteredRecurrings"
              :search="search"
              :loading="loading"
              :show-select="!isGroupedByChecked"
              v-model="selectedDrips"
              @toggle-select-all="selectAll"
              @update:options="onOptionsUpdate"
              :options.sync="options"
              :server-items-length="totalLength"
              :footer-props="{
                'items-per-page-options': [10, 25, 500],
              }"
              :disable-filtering="!isGroupedByChecked"
              loading-text="Loading Recurring Notifications ..."
              class="elevation-1"
            >
              <template v-slot:[`item.schedule_date_start`]="{ item }">
                <span v-if="item['schedules'] !== undefined">{{
                  item["schedules"][0] !== undefined
                    ? item["schedules"][0]["date_start"]
                    : ""
                }}</span>
              </template>
              <template v-slot:[`item.title`]="{ item }">
                <strong>{{ item.title }}</strong
                ><br />
                <p v-if="!hasSimplePreviewPermission">{{ item.body }}</p>
                <v-edit-dialog
                  :return-value.sync="item.url"
                  v-if="!hasSimplePreviewPermission"
                >
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <span class="recurring-link" v-bind="attrs" v-on="on">
                        {{ item.url }}
                      </span>
                    </template>
                    <span>Click To Reveal</span>
                  </v-tooltip>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.url"
                      label="Edit"
                      color="#2196f3"
                      single-line
                      counter
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <!-- <span style="color: #2196f3">{{ item.url }}</span> -->
              </template>
              <template v-slot:[`item.schedule_time`]="{ item }">
                <span
                  v-if="
                    item['schedules'] !== undefined
                      ? item['schedules'][0].type
                      : ''
                  "
                  >{{
                    item["schedules"] !== undefined
                      ? item["schedules"][0]["frequency"]
                      : ""
                  }}</span
                >
                {{
                  item["schedules"] && item["schedules"][0] !== undefined
                    ? item["schedules"][0]["time"]
                    : ""
                }}</template
              >
              <template v-slot:[`item.drips_count`]="{ item }">
                <v-chip
                  v-if="item['drips_count'] !== undefined"
                  class="ma-2"
                  color="primary"
                  >{{ item["drips_count"] }}</v-chip
                >
              </template>
              <template v-slot:[`item.schedule_date_end`]="{ item }">
                <span v-if="item['schedules'] !== undefined">{{
                  item["schedules"][0] !== undefined
                    ? item["schedules"][0]["date_end"]
                    : ""
                }}</span>
              </template>
              <template v-slot:[`item.is_active`]="{ item }">
                <v-switch
                  v-model="item.is_active"
                  :value="item.is_active"
                  dense
                  :loading="loading"
                  :disabled="!item.drips_count"
                  @click.stop="handleTriggerToToggleTheStatus(item)"
                ></v-switch>
              </template>
              <template v-slot:[`item.schedule`]="{ item }">
                <v-btn
                  :loading="loading"
                  small
                  color="primary"
                  :disabled="!item.drips_count"
                  @click="
                    group_id = item.group_uid;
                    isScheduleUpdatedSuccessfully = false;
                    showUpdateScheduleDialog = true;
                  "
                >
                  Update
                </v-btn>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <!-- REGULAR RECURRING BUTTONS -->
                <div
                  v-if="$route.name === 'Recurring' && !isGroupedByChecked"
                  class="d-flex flex-row justify-content-center w-100"
                >
                  <router-link
                    v-if="hasEditorPermission"
                    :href="$route.path + '/edit/' + item.id"
                    :to="{
                      name: 'EditRecurr',
                      params: {
                        recurr_id: item.id,
                        pageLength: itemsPerPage,
                        pageNumber: page,
                      },
                    }"
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    <v-btn :loading="loading" dark small color="success">
                      <v-icon dark small> mdi-pencil </v-icon>
                    </v-btn></router-link
                  >
                  <v-btn
                    :loading="loading"
                    @click="
                      questionType = 'default';
                      shwQuestion = true;
                      group_id = item.group_id;
                      id = item.id;
                    "
                    dark
                    small
                    color="error"
                  >
                    <v-icon dark small> mdi-trash-can-outline </v-icon>
                  </v-btn>
                </div>
                <!-- RECURRING GROUPS BUTTONS -->
                <div
                  v-if="isGroupedByChecked && $route.name === 'Recurring'"
                  class="d-flex flex-row justify-content-center w-100"
                >
                  <v-btn
                    :loading="loading"
                    dark
                    small
                    color="success"
                    class="mr-2"
                    @click="
                      selectedGroupId = item.group_uid;
                      isPopUpGroupedRecurringVisible = true;
                    "
                  >
                    <v-icon dark small> mdi-plus </v-icon>
                  </v-btn>
                  <v-btn
                    :loading="loading"
                    dark
                    small
                    color="primary"
                    class="mr-2"
                    @click="
                      $router.push({
                        name: 'GroupedRecurrings',
                        params: { group_id: item.group_uid },
                      })
                    "
                  >
                    <v-icon dark small> mdi-open-in-new </v-icon>
                  </v-btn>
                  <v-btn
                    :loading="loading"
                    dark
                    small
                    color="error"
                    @click="
                      questionType = 'group';
                      group_id = item.group_uid;
                      id = item.id;
                      shwQuestion = true;
                    "
                  >
                    <v-icon dark small> mdi-trash-can-outline </v-icon>
                  </v-btn>
                </div>
                <!-- GROUPED RECURRING BUTTONS -->
                <div
                  v-if="$route.name === 'GroupedRecurrings'"
                  class="d-flex flex-row justify-content-center w-100"
                >
                  <v-btn
                    :loading="loading"
                    @click="
                      questionType = 'groupedRecurring';
                      group_id = item.group_id;
                      id = item.id;
                      shwQuestion = true;
                    "
                    dark
                    small
                    color="error"
                  >
                    <v-icon dark small> mdi-trash-can-outline </v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card>

          <!-- Error -->
          <Error v-if="error" :error="error" />

          <!-- Spinner -->
          <Spinner
            v-if="processLoading"
            class="loading-spinner--center"
            style="position: fixed !important"
          />
        </div>
      </v-main>
    </v-app>

    <!-- Success Snackbar -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <SuccessSnackbar
        v-if="success"
        :message="successText"
        @update-success="handleUpdateToSuccessSnackbar"
      />
    </transition>
    <!-- Failure Snackbar -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <FailureSnackbar
        v-if="failure"
        :message="failureText"
        @update-failure="handleUpdateToFailureSnackbar"
      />
    </transition>

    <!-- Pop-Up For Changing Links -->
    <dialog-window
      v-if="changeLinksPopUp && selectedDrips.length"
      @closeDialogOutside="changeLinksPopUp = !changeLinksPopUp"
      @confirmed="change($event)"
      :loading="isDialogLoading"
    >
      <template #header> Change links </template>
      <template #disagreeBtnText> Cancel </template>
      <template #agreeBtnText> Change </template>
    </dialog-window>

    <!-- Warning Pop Up  -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <Warnings
        v-if="warningPopUp && !selectedDrips.length"
        warningText="Select drips!"
      />
    </transition>

    <!-- Questions Pop Ups -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <Question
        v-if="shwSaveAsATailQuestionPopUp"
        @didClose="shwSaveAsATailQuestionPopUp = false"
        @confirmed="saveAsRecurringTail"
        title="Would you like to save selected recurring messages as a tail?"
        confirmButtonText="Confirm"
        cancelButtonText="Cancel"
        dismissTitle="Canceled!"
        confirmButtonClasses="btn btn-success"
        cancelButtonClasses="btn btn-success"
        successIcon="success"
        errorIcon="error"
      />
    </transition>

    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <Question
        v-if="shwQuestion"
        @didClose="shwQuestion = false"
        @confirmed="handleConfirmed"
        @notConfirmed="handleNotConfirmed"
        :title="questionContent[questionType].title"
        :text="questionContent[questionType].text"
        :confirmButtonText="questionContent[questionType].confirmButtonText"
        :cancelButtonText="questionContent[questionType].cancelButtonText"
        :isConfirmedTitle="questionContent[questionType].isConfirmedTitle"
        :isConfirmedText="questionContent[questionType].isConfirmedText"
        :dismissTitle="questionContent[questionType].dismissTitle"
        :dismissText="questionContent[questionType].dismissText"
        confirmButtonClasses="btn btn-success"
        cancelButtonClasses="btn btn-success"
        successIcon="success"
        errorIcon="success"
      />
    </transition>

    <!-- <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <Question
        v-if="shwQuestion && !selectedDrips.length"
        @didClose="shwQuestion = false"
        @confirmed="handleConfirmed"
        @notConfirmed="handleNotConfirmed"
        :title="questionContent[questionType].title"
        :text="questionContent[questionType].text"
        :confirmButtonText="questionContent[questionType].confirmButtonText"
        :cancelButtonText="questionContent[questionType].cancelButtonText"
        :isConfirmedTitle="questionContent[questionType].isConfirmedTitle"
        :isConfirmedText="questionContent[questionType].isConfirmedText"
        :dismissTitle="questionContent[questionType].dismissTitle"
        :dismissText="questionContent[questionType].dismissText"
        confirmButtonClasses="btn btn-success"
        cancelButtonClasses="btn btn-success"
        successIcon="success"
        errorIcon="success"
      />
    </transition> -->

    <AttachRecurringToGroupDialog
      :groupId="selectedGroupId"
      :value="isPopUpGroupedRecurringVisible"
      @close="isPopUpGroupedRecurringVisible = false"
    />

    <CreateRecurringGroup
      :isOpened="isPopUpGroupCreationVisible"
      @close="isPopUpGroupCreationVisible = false"
      @checkLoading="loading = $event"
    />

    <UpdateScheduleDialog
      :isOpened="showUpdateScheduleDialog"
      :groupUid="group_id"
      @close="showUpdateScheduleDialog = false"
      @checkClosing="isScheduleUpdatedSuccessfully = $event"
      @checkLoading="loading = $event"
    />
  </div>
</template>

<script>
import "animate.css";
//import "../../../assets/styles/main.css";
import { mapState, mapActions, mapGetters } from "vuex";
import Drip from "../../../apis/Drip.js";
//import Drip from "../../../apis/Drip.js";
//import AsideBar from "../../websiteDash/AsideBar.vue";
import Question from "../../popUps/Question.vue";
import Error from "../../popUps/Error.vue";
import Warnings from "../../popUps/Warnings.vue";
import SuccessSnackbar from "../../popUps/SuccessSnackbar.vue";
import FailureSnackbar from "../../popUps/FailureSnackbar.vue";
import DialogWindow from "../../popUps/DialogWindow.vue";
import Spinner from "../../popUps/Spinner.vue";

import common from "../../../mixins/common";

export default {
  mixins: [common],
  components: {
    AsideBar: () => import("../../websiteDash/AsideBar.vue"),
    AttachRecurringToGroupDialog: () =>
      import("./AttachRecurringToGroupDialog.vue"),
    CreateRecurringGroup: () => import("./CreateRecurringGroup.vue"),
    UpdateScheduleDialog: () => import("./UpdateScheduleDialog.vue"),
    Question,
    DialogWindow,
    SuccessSnackbar,
    FailureSnackbar,
    Warnings,
    Spinner,
    Error,
  },
  data() {
    return {
      success: false,
      successText: "",
      failure: false,
      failureText: "",
      selectedSwitchId: null,
      showUpdateScheduleDialog: false,

      questionType: "default",
      questionContent: {
        default: {
          title: "What do you want to do with this?",
          text: "You can choose to either save it as a draft or delete it.",
          confirmButtonText: "Save as draft",
          cancelButtonText: "Delete",
          isConfirmedTitle: "Saved!",
          isConfirmedText: "This recurring drip is now in your drafts.",
          dismissTitle: "Deleted!",
          dismissText: "The recurring drip has been removed.",
        },
        group: {
          title: "Are you sure you want to delete it?",
          text: "This action will remove recurring group permanently.",
          isConfirmedText: "",
          isConfirmedTitle: "",
          confirmButtonText: "Delete",
          cancelButtonText: "Cancel",
          dismissTitle: "Deleted!",
          dismissText: "All recurring group has been successfully removed.",
        },
        groupedRecurring: {
          title: "Are you sure you want to detach these recurring messages?",
          text: "This action will detach all selected recurring messages from the group?",
          isConfirmedText: "",
          isConfirmedTitle: "",
          confirmButtonText: "Detach",
          cancelButtonText: "Cancel",
          dismissTitle: "Detached!",
          dismissText:
            "All selected recurring messages have been successfully detached.",
        },
      },

      sendTimeForSearching: "",
      selectedExternalForSorting: [],
      selectedAudienceForSorting: [],
      selectedSendTimeForSorting: [],
      selectedGroupId: null,
      openTreeview: [],
      itemsSendTime: [],
      isPopUpGroupedRecurringVisible: false,
      isPopUpGroupCreationVisible: false,
      externalAdverts: [
        {
          id: 0,
          name: "Adverts for external push:",
          children: [
            {
              id: 1,
              name: "evadav",
            },
          ],
        },
      ],
      itemsSendTime: [
        {
          id: 0,
          name: "Send Time:",
          children: [
            {
              id: 1,
              name: "",
            },
          ],
        },
      ],
      itemsAudienceFilters: [
        {
          id: 1,
          name: "Audience Filters:",
          children: [
            {
              id: "null",
              name: "Without audience",
            },
          ],
        },
      ],
      isScheduleUpdatedSuccessfully: false,
      currentDomain: window.location.href,
      inx: 1,
      selectedRec: "",
      changeLinkBtn: false,
      shwSaveAsATailQuestionPopUp: false,
      warningPopUp: false,
      search: "",
      changeSchedulePopUp: false,
      changeLinksPopUp: false,
      endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      modal: false,
      btnName: "Select All",
      loading: true,
      status: true,
      groupOfIds: [],
      selectedId: null,
      selectedDrips: [],
      continueProcess: false,
      shwQuestion: false,
      group_id: "",
      id: "",
      page: 1,
      options: {},
      items: [],
      totalItems: 0,
      itemsPerPage: 10,
      totalLength: null,
      loading: true,
      processLoading: false,
      isDialogLoading: false,
      isGroupedByChecked: false,
    };
  },
  created() {
    this.itemsPerPage = parseInt(sessionStorage.getItem("pageLength"))
      ? parseInt(sessionStorage.getItem("pageLength"))
      : this.itemsPerPage;

    this.page = parseInt(sessionStorage.getItem("pageNumber"))
      ? parseInt(sessionStorage.getItem("pageNumber"))
      : this.page;
  },
  mounted() {
    console.log(this.$route.name === "GroupedRecurrings", this.$route)
    this.isGroupedByChecked = this.$route.name === "GroupedRecurrings"
    this.getAllFilters(
      `?where[type]=audience&where[domain_id]=${this.$route.params.id}&where[is_system]=0`
    ).then((response) => {
      for (let audience of response.data.data) {
        this.itemsAudienceFilters[0].children.push({
          id: audience.id,
          name: audience.name,
        });
      }
    });

    //this.fetchData();

    this.options = {
      itemsPerPage: this.itemsPerPage,
      page: this.page,
    };

    // Empty Array After Clicking Back Button
    window.addEventListener("popstate", () => {
      //this.$store.state.recurringDrip.recurringDrips = [];

      if (sessionStorage.length) {
        sessionStorage.removeItem("pageLength");
        sessionStorage.removeItem("pageNumber");
      }
    });
  },
  computed: {
    ...mapState({
      audienceRecords: (state) => state.audience.audienceRecords,
      recurringDrips: (state) => state.recurringDrip.recurringDrips,
      error: (state) => state.recurringDrip.errorRecurringDrip,
    }),
    ...mapGetters(["permissions"]),

    hasEditorPermission() {
      return this.permissions.includes("recurring_message_edit");
    },
    hasSimplePreviewPermission() {
      return this.permissions.includes("recurring_message_simple_preview");
    },
    hasCreatorPermission() {
      return this.permissions.includes("recurring_message_create");
    },
    hasGroupVisiblePermission() {
      return this.permissions.includes("recurring_message_group");
    },
    isGroupByCheckboxVisible() {
      return this.$route.name === "Recurring";
    },
    isRegularRecurringRoute() {
      return this.$route.name === "Recurring";
    },
    headers() {
      if (
        !this.isGroupedByChecked ||
        this.$route.name === "GroupedRecurrings"
      ) {
        return [
          {
            text: "Id",
            value: "id",
            align: "left",
            divider: true,
            class: "table-header--color border-left",
            cellClass: "border-left",
            sortable: true,
            groupable: false,
          },
          {
            text: "Notification",
            value: "title",
            align: "left",
            divider: true,
            class: "table-header--color",
            width: "400px",
            sortable: true,
            groupable: false,
          },
          {
            text: "Time",
            value: "schedule_time",
            align: "center",
            divider: true,
            class: "table-header--color",
            sortable: true,
            groupable: false,
          },
          {
            text: "Date Start",
            value: "schedule_date_start",
            align: "center",
            divider: true,
            class: "table-header--color",
            sortable: true,
            groupable: false,
          },
          {
            text: "Date End",
            value: "schedule_date_end",
            align: "center",
            divider: true,
            class: "table-header--color",
            sortable: true,
            groupable: false,
          },
          {
            text: "Actions",
            value: "action",
            sortable: false,
            align: "center",
            class: "table-header--color",
            groupable: false,
          },
        ];
      } else {
        return [
          {
            text: "ID",
            value: "id",
            sortable: true,
            align: "center",
            divider: true,
            class: "table-header--color",
            sort: (a, b) => a.localeCompare(b),
            groupable: false,
          },
          {
            text: "Group UID",
            value: "group_uid",
            sortable: true,
            align: "center",
            divider: true,
            class: "table-header--color",
            groupable: false,
          },
          {
            text: "Domain ID",
            value: "domain_id",
            sortable: true,
            align: "center",
            divider: true,
            class: "table-header--color",
            groupable: false,
          },
          {
            text: "Name",
            value: "name",
            sortable: true,
            align: "left",
            divider: true,
            class: "table-header--color",
            groupable: false,
          },
          {
            text: "Created At",
            value: "created_at",
            sortable: true,
            align: "center",
            divider: true,
            class: "table-header--color",
            groupable: false,
          },
          {
            text: "Updated At",
            value: "updated_at",
            sortable: true,
            align: "center",
            divider: true,
            class: "table-header--color",
            groupable: false,
          },
          {
            text: "Drips Count",
            value: "drips_count",
            sortable: true,
            align: "center",
            divider: true,
            class: "table-header--color",
            groupable: false,
          },
          {
            text: "Status",
            value: "is_active",
            sortable: true,
            align: "center",
            divider: true,
            class: "table-header--color",
            groupable: false,
          },
          {
            text: "Schedule",
            value: "schedule",
            sortable: false,
            align: "center",
            divider: true,
            class: "table-header--color",
            groupable: false,
          },
          {
            text: "Actions",
            value: "action",
            sortable: false,
            align: "center",
            class: "table-header--color",
            groupable: false,
          },
        ];
      }
    },
    getNotificationsEndpoint() {
      if (this.$route.name === "Recurring") {
        return "getRecurringDrips";
      } else if (
        this.$route.name === "GroupedRecurrings" ||
        this.isGroupedByChecked
      ) {
        return "getRecurringDripsByGroupId";
      }
    },
    // customSort() {
    //   return this.isGroupedByChecked ? this.defaultSort : undefined;
    // },
    filteredRecurrings() {
      if (
        !this.isGroupedByChecked ||
        this.$route.name === "GroupedRecurrings"
      ) {
        return this.recurringDrips;
      }

      const search = this.search?.toLowerCase() || "";
      if (!search) return this.items;

      return this.items.filter((group) => {
        return (
          group.id?.toString().includes(search) ||
          group.name?.toLowerCase().includes(search) ||
          group.domain_id.toString().includes(search) ||
          group.group_uid.toString().includes(search)
        );
      });
    },
    currentRouteName() {
      if (this.$route.name === "Recurring" && this.isGroupedByChecked) {
        return "Recurring Groups";
      }

      if (this.$route.name === "GroupedRecurrings") {
        return "Grouped Recurring Notifications";
      }

      if (this.$route.name === "Recurring" && !this.isGroupedByChecked) {
        return "Recurring Notifications";
      }
    },
  },
  methods: {
    ...mapActions([
      "resetRecurringDrips",
      "getRecurringDrips",
      "getRecurringDripsByGroupId",
      "getAllFilters",
      "deleteRecurringDrip",
      "deleteRecurringDripArray",
      "detachRecurringFromGroup",
      "deleteRecurringGroup",
      "createOrUpdate",
      "getRecurringGroupIds",
      "toggleRecurringGroup",
    ]),
    onOptionsUpdate(newOptions) {
      this.options = newOptions;
      this.fetchData();
    },
    async fetchData() {
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;

      if (
        !this.isGroupedByChecked ||
        this.$route.name === "GroupedRecurrings"
      ) {
        this.loading = true;
        await this.obtainRecurringDrips(this.options);

        this.items = this.recurringDrips;

        this.loading = false;
      } else {
        await this.getRecurringGroupIds(this.$route.params.id);

        this.items = this.recurringDrips;
        this.totalLength = this.items.length;

        if (sortBy?.length) {
          const key = sortBy[0];
          const desc = sortDesc[0];
          items.sort((a, b) => {
            if (a[key] < b[key]) return desc ? 1 : -1;
            if (a[key] > b[key]) return desc ? -1 : 1;
            return 0;
          });
        }

        const start = (page - 1) * itemsPerPage;
        this.items = this.recurringDrips.slice(start, start + itemsPerPage);
        this.totalLength = this.recurringDrips.length;
      }
    },
    handleConfirmed() {
      if (this.questionType === "default") {
        this.createDrafts({ id: this.id });
      } else if (this.questionType === "group") {
        this.loading = true;

        this.deleteRecurringGroup(this.group_id)
          .then(() => {
            this.successText = "Deleted successfully!";
            this.success = true;
          })
          .catch((error) => {
            this.failureText = error?.response?.message || error;
            this.failure = true;
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (this.questionType === "groupedRecurring") {
        this.loading = true;

        const payload = {
          drip_ids: [],
        };

        payload.drip_ids = this.selectedDrips.length
          ? this.selectedDrips.map((el) => el.id)
          : [this.id];

        this.detachRecurringFromGroup({
          groupId: this.$route.params.group_id,
          payload,
        })
          .then(() => {
            this.successText = "Detached successfully!";
            this.success = true;
          })
          .catch((error) => {
            this.failureText = error?.response?.message || error;
            this.failure = true;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    handleTriggerToToggleTheStatus(item) {
      this.loading = true;

      this.toggleRecurringGroup({
        groupId: item.group_uid,
        payload: { is_active: item.is_active },
      })
        .then(() => {
          this.successText = "Status updated successfully!";
          this.success = true;
          this.selectedSwitchId = item.id;
        })
        .catch((error) => {
          this.failureText = error?.response?.message || error;
          this.failure = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleNotConfirmed() {
      if (this.questionType === "default") {
        this.deleteRecurring(this.group_id, this.id);
      } else if (this.questionType === "group") {
      }
    },
    toggleMenu() {
      this.openTreeview = [];
    },
    treeviewActiveAudienceFilters(array) {
      this.selectedAudienceForSorting = array;
    },
    treeviewActiveSendTime(array) {
      this.selectedSendTimeForSorting = array;
    },
    treeviewActiveExternal(array) {
      this.selectedExternalForSorting = array;
    },
    triggerPag(pagination) {},
    async change(event) {
      try {
        this.isDialogLoading = true;

        if (event) {
          for (let i in this.selectedDrips) {
            this.selectedDrips[i].url = event;

            this.selectedDrips[i].customization.button1 !== undefined
              ? (this.selectedDrips[i].customization.button1.url = event)
              : null;
            this.selectedDrips[i].customization.button2 !== undefined
              ? (this.selectedDrips[i].customization.button2.url = event)
              : null;
            if (this.selectedDrips[i].schedules !== undefined) {
              this.selectedDrips[i].schedule =
                this.selectedDrips[i].schedules[0];
            }

            if (this.selectedDrips[i]["schedule"].type === "one") {
              Object.assign(this.selectedDrips[i].schedule, {
                type: "one",
                name: "one",
                choose_time: [
                  {
                    domain_id: this.$route.params.id,
                    id: this.selectedDrips[i].schedule.id,
                    date_start: this.selectedDrips[i].schedule.date_start,
                    time: this.selectedDrips[i].schedule.time,
                    timezone: this.selectedDrips[i].schedule.timezone,
                  },
                ],
              });
              delete this.selectedDrips[i].schedule.name;
              delete this.selectedDrips[i].schedule.date_end;
            } else if (this.selectedDrips[i]["schedule"].type === "multiply") {
              this.selectedDrips[i].schedule = {
                domain_id: this.$route.params.id,
                type: "multiply",
                name: "multiply",
                choose_time: [],
              };

              for (let j in this.selectedDrips[i]["schedules"]) {
                this.selectedDrips[i].schedule.choose_time.push({
                  id: this.selectedDrips[i].schedules[j].id,
                  date_start: this.selectedDrips[i].schedules[j].date_start,
                  time: this.selectedDrips[i].schedules[j].time,
                  timezone: this.selectedDrips[i].schedules[j].timezone,
                });
              }

              delete this.selectedDrips[i].schedule.name;
              delete this.selectedDrips[i].schedule.date_end;
            } else if (this.selectedDrips[i]["schedule"].type === "recurring") {
              this.selectedDrips[i].schedule = {
                domain_id: this.$route.params.id,
                id: this.selectedDrips[i].schedule.id,
                type: "recurring",
                name: "recurring",
                frequency: this.selectedDrips[i].schedule.frequency,
                time: this.selectedDrips[i].schedule.time,
                date_start: this.selectedDrips[i].schedule.date_start,
                date_end: this.selectedDrips[i].schedule.date_end,
                days_of_week:
                  "Monday Tuesday Wednesday Thursday Friday Saturday Sunday",
                timezone: this.selectedDrips[i].schedule.timezone,
              };
            }

            if (
              this.selectedDrips[i]["schedules"] !== undefined &&
              this.selectedDrips[i]["schedules"][0]["frequency"] !== undefined
            ) {
              delete this.selectedDrips[i]["schedules"][0]["frequency"];
            }

            delete this.selectedDrips[i].schedules;
            delete this.selectedDrips[i].schedule.created_at;
            delete this.selectedDrips[i].schedule.group_id;
            delete this.selectedDrips[i].schedule.last_disp_date;
            delete this.selectedDrips[i].schedule.next_disp_date;
            delete this.selectedDrips[i].schedule.pivot;
            delete this.selectedDrips[i].schedule.updated_at;
            delete this.selectedDrips[i].schedule.after_days;
            delete this.selectedDrips[i].schedule.after_hours;
            delete this.selectedDrips[i].schedule.after_mins;
            delete this.selectedDrips[i].schedule.from_when;
            delete this.selectedDrips[i].schedule.is_active;
          }

          await this.createOrUpdate({
            json: this.selectedDrips,
            withReplaceUrlButtons: true,
          });

          const groupIdParams =
            this.$route.name === "GroupedRecurrings"
              ? `&whereRelation[groups]=${this.$route.params.group_id}`
              : "";
          await this[this.getNotificationsEndpoint]({
            params: `?order_by=id:desc&where[is_active]=1&with[schedules.audiences]=*&where[domain_id]=${
              this.$route.params.id
            }&limit=100&paginate=true&pageLength=${10}&page=${1}${groupIdParams}`,
          });

          this.successText =
            "The recurring links have been changed successfully!";
          this.success = true;

          this.selectedDrips = [];
        } else {
          this.fireError = true;
        }
      } catch (e) {
        this.failureText = e;
        this.failure = true;

        throw new Error(e);
      } finally {
        setTimeout(() => {
          this.changeLinksPopUp = false;
          this.isDialogLoading = false;
        }, 1000);
      }
    },
    async changeSchedule(event) {
      try {
        this.isDialogLoading = true;

        if (event) {
          for (let i in this.selectedDrips) {
            if (this.selectedDrips[i].schedules !== undefined) {
              this.selectedDrips[i].schedule =
                this.selectedDrips[i].schedules[0];
            }

            if (this.selectedDrips[i]["schedule"].type === "one") {
              Object.assign(this.selectedDrips[i].schedule, {
                type: "one",
                name: "one",
                choose_time: [
                  {
                    domain_id: this.$route.params.id,
                    id: this.selectedDrips[i].schedule.id,
                    date_start: this.selectedDrips[i].schedule.date_start,
                    time: this.selectedDrips[i].schedule.time,
                    timezone: this.selectedDrips[i].schedule.timezone,
                  },
                ],
              });
              delete this.selectedDrips[i].schedule.name;
              delete this.selectedDrips[i].schedule.date_end;
            } else if (this.selectedDrips[i]["schedule"].type === "multiply") {
              this.selectedDrips[i].schedule = {
                domain_id: this.$route.params.id,
                type: "multiply",
                name: "multiply",
                choose_time: [],
              };

              for (let j in this.selectedDrips[i]["schedules"]) {
                this.selectedDrips[i].schedule.choose_time.push({
                  id: this.selectedDrips[i].schedules[j].id,
                  date_start: this.selectedDrips[i].schedules[j].date_start,
                  time: this.selectedDrips[i].schedules[j].time,
                  timezone: this.selectedDrips[i].schedules[j].timezone,
                });
              }

              delete this.selectedDrips[i].schedule.name;
              delete this.selectedDrips[i].schedule.date_end;
            } else if (this.selectedDrips[i]["schedule"].type === "recurring") {
              this.selectedDrips[i].schedule = {
                domain_id: this.$route.params.id,
                id: this.selectedDrips[i].schedule.id,
                type: "recurring",
                name: "recurring",
                frequency: this.selectedDrips[i].schedule.frequency,
                time: this.selectedDrips[i].schedule.time,
                date_start: this.selectedDrips[i].schedule.date_start,
                date_end: this.endDate,
                days_of_week:
                  "Monday Tuesday Wednesday Thursday Friday Saturday Sunday",
                timezone: this.selectedDrips[i].schedule.timezone,
              };
            }

            if (
              this.selectedDrips[i]["schedules"] !== undefined &&
              this.selectedDrips[i]["schedules"][0]["frequency"] !== undefined
            ) {
              delete this.selectedDrips[i]["schedules"][0]["frequency"];
            }

            delete this.selectedDrips[i].schedules;
            delete this.selectedDrips[i].schedule.created_at;
            delete this.selectedDrips[i].schedule.group_id;
            delete this.selectedDrips[i].schedule.last_disp_date;
            delete this.selectedDrips[i].schedule.next_disp_date;
            delete this.selectedDrips[i].schedule.pivot;
            delete this.selectedDrips[i].schedule.updated_at;
            delete this.selectedDrips[i].schedule.after_days;
            delete this.selectedDrips[i].schedule.after_hours;
            delete this.selectedDrips[i].schedule.after_mins;
            delete this.selectedDrips[i].schedule.from_when;
            delete this.selectedDrips[i].schedule.is_active;
          }

          await this.createOrUpdate({
            json: this.selectedDrips,
            withReplaceUrlButtons: true,
          });

          const groupIdParams =
            this.$route.name === "GroupedRecurrings"
              ? `&whereRelation[groups]=${this.$route.params.group_id}`
              : "";

          setTimeout(async () => {
            await this[this.getNotificationsEndpoint]({
              params: `?order_by=id:desc&where[is_active]=1&with[schedules.audiences]=*&where[domain_id]=${
                this.$route.params.id
              }&limit=100&paginate=true&pageLength=${10}&page=${1}${groupIdParams}`,
            });
            this.successText =
              "The recurring links have been changed successfully!";
            this.success = true;

            this.selectedDrips = [];
          }, 1000);
        } else {
          this.fireError = true;
        }
      } catch (e) {
        this.failureText = e;
        this.failure = true;

        throw new Error(e);
      } finally {
        setTimeout(() => {
          this.isDialogLoading = false;
          this.changeSchedulePopUp = false;
        }, 1000);
      }
    },
    saveAsRecurringTail() {
      this.loading = true;
      this.processLoading = true;

      let deepCopyOfRecurrings = JSON.parse(JSON.stringify(this.selectedDrips));
      let recurringTails = deepCopyOfRecurrings.map((recurring) => {
        if (recurring.schedules[0].audiences !== undefined) {
          delete recurring.schedules[0].audiences;
        }

        recurring.schedules[0].type = "tail-recurring";
        recurring.schedule = recurring.schedules[0];

        delete recurring.schedules;

        return recurring;
      });

      Drip.createOrUpdate("recurring", recurringTails)
        .then(() => {
          let indexOfSelectedDrip = null;

          for (let drip of this.selectedDrips) {
            indexOfSelectedDrip = this.recurringDrips.findIndex(
              (el) => el.id == drip["id"]
            );

            this.recurringDrips.splice(indexOfSelectedDrip, 1);
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
            this.processLoading = false;
          }, 1000);
        });
    },
    createDrafts(...args) {
      this.loading = true;
      this.processLoading = true;

      if (args[0]["id"] != undefined) {
        let selectedRecurring = [];

        selectedRecurring.push(
          this.recurringDrips.find((el) => el.id == args[0]["id"])
        );

        selectedRecurring[0]["is_active"] = 0;
        selectedRecurring[0]["schedule"] = selectedRecurring[0]["schedules"][0];
        delete selectedRecurring[0]["schedules"];

        Drip.createOrUpdate("recurring", selectedRecurring)
          .then(() => {
            let indexOfSelectedDrip = this.recurringDrips.findIndex(
              (el) => el.id == args[0]["id"]
            );

            this.recurringDrips.splice(indexOfSelectedDrip, 1);
          })
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
              this.processLoading = false;
            }, 2000);
          });
      } else if (!Object.hasOwn(args[0], "id") && args[0].length) {
        for (let el of this.selectedDrips) {
          el["is_active"] = 0;
          el["schedule"] = el["schedules"][0];
          delete el["schedules"];
        }

        Drip.createOrUpdate("recurring", this.selectedDrips)
          .then(() => {
            let indexOfSelectedDrip = null;

            for (let drip of this.selectedDrips) {
              indexOfSelectedDrip = this.recurringDrips.findIndex(
                (el) => el.id == drip["id"]
              );

              this.recurringDrips.splice(indexOfSelectedDrip, 1);
            }

            if (!this.recurringDrips.length) {
              this.obtainRecurringDrips({
                page: this.page - 1,
                itemsPerPage: this.itemsPerPage,
              });
            }
            this.totalLength -= this.selectedDrips.length;

            this.selectedDrips = [];
          })
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
              this.processLoading = false;
            }, 2000);
          });
      }

      this.shwQuestion = false;
    },
    searchRecurring(text) {
      if (this.isGroupedByChecked) return;

      if (!this.isGroupedByChecked) {
        if (text.length >= 3) {
          this.obtainRecurringDrips({
            page: this.page,
            itemsPerPage: this.itemsPerPage,
          });
        } else if (!text) {
          this.obtainRecurringDrips({
            page: this.page,
            itemsPerPage: this.itemsPerPage,
          });
        }
      }
    },
    objectIndex(created_at) {
      let result = this.recurringDrips.findIndex(
        (el) => el.created_at === created_at
      );
      return result;
    },
    async deleteRecurring(group_id, id) {
      this.processLoading = true;
      this.loading = true;

      if (this.selectedDrips.length > 1) {
        let arrOfIds = this.selectedDrips.map(function (item) {
          return item["id"];
        });

        arrOfIds = arrOfIds.toString().replace(/[\[\]']+/g, "");

        await this.deleteRecurringDripArray({
          domainId: this.$route.params.id,
          ids: arrOfIds,
        }).then(() => {
          if (!this.recurringDrips.length) {
            this.obtainRecurringDrips({
              page: this.page - 1,
              itemsPerPage: this.itemsPerPage,
            });
          }
          this.totalLength -= this.selectedDrips.length;
          //this.processLoading = false;
        });
      } else {
        await this.deleteRecurringDrip([group_id, id]).then(() => {
          if (!this.recurringDrips.length) {
            this.obtainRecurringDrips({
              page: this.page - 1,
              itemsPerPage: this.itemsPerPage,
            });
          }
          this.totalLength -= 1;
        });
      }

      setTimeout(() => {
        this.processLoading = false;
        this.loading = false;
        this.shwQuestion = false;
        this.selectedDrips = [];
      }, 500);
    },
    selectAll() {
      this.processLoading = true;
      this.loading = true;

      let audienceFilterParams = this.selectedAudienceForSorting.length
        ? `&whereRelation[schedules.audiences]=segments.id::${this.selectedAudienceForSorting}`
        : "";

      if (this.selectedDrips.length < this.totalLength) {
        Drip.get(
          "recurring",
          `?where[is_active]=1&with[schedules.audiences]=*&where[domain_id]=${this.$route.params.id}&whereRelation[schedules]=type::recurring` +
            audienceFilterParams
        ).then((response) => {
          this.selectedDrips = response.data.data;
        });
      } else if (this.selectedDrips.length === this.totalLength) {
        this.selectedDrips = [];
      }
    },
    handleClick(item) {
      this.selectedId = item.id;
    },
    obtainRecurringDrips(options) {
      if (options) {
        let searchParams =
          this.search.length >= 3
            ? `&like[]=title::${this.search}&like[]=body::${this.search}&like[]=id::${this.search}`
            : "";
        let additAudParams = this.selectedAudienceForSorting.length
          ? `&whereRelation[schedules.audiences]=segments.id::${this.selectedAudienceForSorting}`
          : "";
        let additTimeParams = this.sendTimeForSearching
          ? `&whereRelation[schedules]=time::${this.sendTimeForSearching}`
          : "";
        let externalPushParams = this.selectedExternalForSorting.length
          ? `&where[external]=${this.selectedExternalForSorting.toString()}`
          : "";
        const groupIdParams =
          this.$route.name === "GroupedRecurrings"
            ? `&whereRelation[groups]=group_uid::${this.$route.params.group_id}`
            : "";
        const sortingParams =
          !this.isGroupedByChecked && options?.sortBy?.length
            ? `&order_by=${options?.sortBy[0]}:${
                options?.sortDesc[0] ? "desc" : "asc"
              }`
            : "&order_by=id:desc";
        const statusParams =
          this.$route.name !== "GroupedRecurrings" || !this.isGroupedByChecked
            ? `&where[is_active]=1`
            : "";

        this[this.getNotificationsEndpoint]({
          params:
            `?&whereRelation[schedules]=type::recurring&with[schedules.audiences]=*&where[domain_id]=${this.$route.params.id}&paginate=true&pageLength=${options.itemsPerPage}&page=${options.page}` +
            searchParams +
            additAudParams +
            additTimeParams +
            externalPushParams +
            groupIdParams +
            sortingParams +
            statusParams,
        }).then((response) => {
          this.totalLength = response.data.data.total;
          this.itemsPerPage = options.itemsPerPage;
          this.page = options.page;
        });
      }
    },
    triggerCheckbox(event) {
      if (event.target.checked) {
        if (!this.groupOfIds.length) {
          this.groupOfIds.push(this.selectedId);
        } else {
          let index = this.groupOfIds.findIndex((el) => el === this.selectedId);

          if (index || index === 0) {
            this.groupOfIds.push(this.selectedId);
          }
        }
      } else if (!event.target.checked) {
        let index = this.groupOfIds.findIndex((el) => el === this.selectedId);
        this.groupOfIds.splice(index, 1);
      }
    },
    defaultSort(items, sortBy, sortDesc) {
      if (!sortBy) return items;

      return items.sort((a, b) => {
        const valA = a[sortBy];
        const valB = b[sortBy];

        if (valA == null) return sortDesc ? -1 : 1;
        if (valB == null) return sortDesc ? 1 : -1;

        if (valA === valB) return 0;

        return (valA > valB ? 1 : -1) * (sortDesc ? -1 : 1);
      });
    },
    defaultFilter() {
      if (!this.search) return false;

      return this.recurringDrips.filter((el) => {
        return (
          el.id.toLowerCase().indexOf(this.search.toString().toLowerCase()) !==
            -1 ||
          el.name
            .toLowerCase()
            .indexOf(this.search.toString().toLowerCase()) !== -1 ||
          el.group_uid
            .toString()
            .toLowerCase()
            .indexOf(this.search.toString().toLowerCase()) !== -1 ||
          el.domain_id
            .toString()
            .toLowerCase()
            .indexOf(this.search.toString().toLowerCase()) !== -1
        );
      });
    },
  },
  watch: {
    // "recurringDrips.length"(length) {
    //   if (this.isGroupedByChecked) {
    //     this.totalLength = length;
    //     this.items = this.recurringDrips;
    //   }
    // },
    "$route": {
      async handler(value) {
        this.pageLength = 10;
        this.page = 1;
        this.options.page = 1;
        this.options.itemsPerPage = 10;
        console.log("🚀 ~ handler ~ value:", value)
        if (value.name === "GroupedRecurrings" || (this.isRegularRecurringRoute && this.isGroupedByChecked)) {
          this.loading = true;
          await this.fetchData();
          this.loading = false;
        } else {
          this.resetRecurringDrips();
        }
      },
      deep: true,
      immediate: true,
    },
    async isGroupedByChecked() {
      this.loading = true;

      await this.fetchData();

      this.loading = false;
    },
    selectedDrips: {
      handler(drips) {
        if (drips.length === 0 || drips.length === this.totalLength) {
          setTimeout(() => {
            this.processLoading = false;
            this.loading = false;
          }, 1000);
        }
      },
      deep: true,
    },
    selectedAudienceForSorting: {
      handler() {
        this.loading = true;

        this.obtainRecurringDrips({
          page: this.options.page,
          itemsPerPage: this.options.itemsPerPage,
        });

        queueMicrotask(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
      },
      deep: true,
      immediate: true,
    },
    selectedExternalForSorting: {
      handler() {
        this.loading = true;

        this.obtainRecurringDrips({
          page: this.options.page,
          itemsPerPage: this.options.itemsPerPage,
        });

        queueMicrotask(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
      },
      deep: true,
      immediate: true,
    },
    selectedRec(filter) {
      if (this.selectedRec && filter != "Without audience") {
        this.resetRecurringDrips();

        this.obtainRecurringDrips({
          itemsPerPage: 15,
          page: 1,
        });
      } else if (filter == "Without audience") {
        let withoutAudience = [];

        Drip.get(
          "recurring",
          `?where[is_active]=1&with[schedules.audiences]=*&where[domain_id]=${this.$route.params.id}`
        ).then((response) => {
          response.data.data.forEach((el) => {
            if (el.schedules !== undefined) {
              el.schedules[0]["audiences"].length === 0
                ? withoutAudience.push(el)
                : null;
            } else if (el.schedule !== undefined) {
              el.schedule["audiences"].length === 0
                ? withoutAudience.push(el)
                : null;
            }
          });
          this.$store.state.recurringDrip.recurringDrips = withoutAudience;
          this.totalLength = withoutAudience.length;
        });
      } else if (!this.selectedRec) {
        this.obtainRecurringDrips({
          itemsPerPage: 15,
          page: 1,
        });
      }
    },
  },
};
</script>

<style scoped>
.v-pagination__item {
  color: #000 !important;
}
.v-pagination__item--active {
  color: #fff !important;
}
.v-list {
  height: 200px;
  overflow: scroll;
}
.act-btn-recur {
  font-size: 12px;
  margin: 0;
  height: fit-content;
}
</style>
